<template>
  <div>
    <!-- 汉堡菜单按钮 -->
    <button
      @click="toggleMenu"
      class="lg:hidden btn-touch p-2 text-gray-600 hover:text-hongtu-primary focus:outline-none"
      aria-label="打开菜单"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          v-if="!isOpen"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
        <path
          v-else
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <!-- 移动端菜单遮罩 -->
    <div
      v-if="isOpen"
      @click="closeMenu"
      class="mobile-menu-overlay"
    ></div>

    <!-- 移动端菜单 -->
    <div
      :class="['mobile-menu', isOpen ? 'mobile-menu-open' : 'mobile-menu-closed']"
    >
      <!-- 菜单头部 -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <div class="flex items-center">
          <img src="../assets/logo.png" alt="红土证券" class="h-8 mr-3" />
          <span class="text-lg font-semibold text-gray-800">红土证券</span>
        </div>
        <button
          @click="closeMenu"
          class="btn-touch p-2 text-gray-400 hover:text-gray-600"
          aria-label="关闭菜单"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- 菜单内容 -->
      <div class="py-4">
        <!-- 主导航菜单 -->
        <nav class="px-4 pb-4">
          <ul class="space-y-1">
            <li v-for="item in navItems" :key="`main-${item.key}`">
              <router-link
                v-if="isInternalRoute(item.key)"
                :to="getInternalRoute(item.key)"
                @click.native="closeMenu"
                class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-hongtu-primary hover:bg-gray-50 rounded-lg transition-colors duration-200"
              >
                {{ item.text }}
              </router-link>
              <a
                v-else
                :href="getExternalHref(item.key)"
                target="_blank"
                rel="noopener noreferrer"
                @click="closeMenu"
                class="block px-4 py-3 text-base font-medium text-gray-700 hover:text-hongtu-primary hover:bg-gray-50 rounded-lg transition-colors duration-200"
              >
                {{ item.text }}
              </a>
            </li>
          </ul>
        </nav>

        <!-- 顶部导航菜单 -->
        <div v-if="topNavItems && topNavItems.length" class="px-4 py-4 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2">
            <div v-for="item in topNavItems" :key="`top-${item.key}`">
              <router-link
                v-if="isInternalRoute(item.key)"
                :to="getInternalRoute(item.key)"
                @click.native="closeMenu"
                class="block px-3 py-2 text-sm text-gray-600 hover:text-hongtu-primary hover:bg-gray-50 rounded-lg transition-colors duration-200"
              >
                {{ item.text }}
              </router-link>
              <a
                v-else
                :href="getExternalHref(item.key)"
                target="_blank"
                rel="noopener noreferrer"
                @click="closeMenu"
                class="block px-3 py-2 text-sm text-gray-600 hover:text-hongtu-primary hover:bg-gray-50 rounded-lg transition-colors duration-200"
              >
                {{ item.text }}
              </a>
            </div>
          </div>
        </div>

        <!-- 登录注册按钮 -->
        <div class="px-4 py-4 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-3">
            <router-link
              v-if="isInternalRoute('nav_login')"
              :to="getInternalRoute('nav_login')"
              @click.native="closeMenu"
              class="btn-touch bg-transparent border border-hongtu-primary text-hongtu-primary py-2 px-3 rounded-lg text-sm font-medium transition-colors duration-200"
            >
              {{ loginText }}
            </router-link>
            <a
              v-else
              :href="getExternalHref('nav_login')"
              target="_blank"
              rel="noopener noreferrer"
              @click="closeMenu"
              class="btn-touch bg-transparent border border-hongtu-primary text-hongtu-primary py-2 px-3 rounded-lg text-sm font-medium transition-colors duration-200"
            >
              {{ loginText }}
            </a>
            <router-link
              v-if="isInternalRoute('nav_register')"
              :to="getInternalRoute('nav_register')"
              @click.native="closeMenu"
              class="btn-touch bg-hongtu-primary text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-hongtu-secondary transition-colors duration-200"
            >
              {{ registerText }}
            </router-link>
            <a
              v-else
              :href="getExternalHref('nav_register')"
              target="_blank"
              rel="noopener noreferrer"
              @click="closeMenu"
              class="btn-touch bg-hongtu-primary text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-hongtu-secondary transition-colors duration-200"
            >
              {{ registerText }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  props: {
    navItems: {
      type: Array,
      default: () => []
    },
    topNavItems: {
      type: Array,
      default: () => []
    },
    contentData: {
      type: Object,
      default: () => ({})
    },
    loginText: {
      type: String,
      default: '登录'
    },
    registerText: {
      type: String,
      default: '注册'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    getRouteConfig(key) {
      const item = this.contentData[key]
      if (item && typeof item === 'object') {
        return {
          route: item.route || '#',
          routeType: item.route_type || 'external'
        }
      }
      return {
        route: '#',
        routeType: 'external'
      }
    },
    isInternalRoute(key) {
      const { routeType } = this.getRouteConfig(key)
      return routeType === 'internal'
    },
    getInternalRoute(key) {
      const { route } = this.getRouteConfig(key)
      return route || '#'
    },
    getExternalHref(key) {
      const { route } = this.getRouteConfig(key)
      let href = route || '#'
      if (href && !href.startsWith('http://') && !href.startsWith('https://')) {
        if (href.includes('.') && !href.includes('/')) {
          href = `https://${href}`
        }
      }
      return href
    },
    toggleMenu() {
      this.isOpen = !this.isOpen
      // 防止背景滚动
      if (this.isOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMenu() {
      this.isOpen = false
      document.body.style.overflow = ''
    }
  },
  beforeDestroy() {
    // 清理样式
    document.body.style.overflow = ''
  }
}
</script>
